"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* AWTRetryPolicy.ts
* Author: Abhilash Panwar (abpanwar)
* Copyright: Microsoft 2016
* Class for retry policy.
*/
var RandomizationLowerThreshold = 0.8;
var RandomizationUpperThreshold = 1.2;
var BaseBackoff = 3000;
var MaxBackoff = 120000;
var AWTRetryPolicy = /** @class */ (function () {
    function AWTRetryPolicy() {
    }
    AWTRetryPolicy.shouldRetryForStatus = function (httpStatusCode) {
        /* The below expression reads that we should only retry for:
            - HttpStatusCodes that are smaller than 300.
            - HttpStatusCodes greater or equal to 500 (except for 501-NotImplement
              and 505-HttpVersionNotSupport).
            - HttpStatusCode 408-RequestTimeout.
           This is based on Microsoft.WindowsAzure.Storage.RetryPolicies.ExponentialRetry class */
        return !((httpStatusCode >= 300 && httpStatusCode < 500 && httpStatusCode !== 408)
            || (httpStatusCode === 501)
            || (httpStatusCode === 505));
    };
    AWTRetryPolicy.getMillisToBackoffForRetry = function (retriesSoFar) {
        var waitDuration = 0;
        var minBackoff = BaseBackoff * RandomizationLowerThreshold;
        var maxBackoff = BaseBackoff * RandomizationUpperThreshold;
        var randomBackoff = Math.floor(Math.random() * (maxBackoff - minBackoff)) + minBackoff;
        waitDuration = Math.pow(4, retriesSoFar) * randomBackoff;
        return Math.min(waitDuration, MaxBackoff);
    };
    return AWTRetryPolicy;
}());
exports.default = AWTRetryPolicy;
